import { render, staticRenderFns } from "./LicenseLabel.vue?vue&type=template&id=2f969e66"
import script from "./LicenseLabel.vue?vue&type=script&lang=js"
export * from "./LicenseLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports